module.exports = __webpack_public_path__ + "static/media/criminal-conduct.ac57df02.svg";